const animA = () => {
  // const ease = [0.9, 0, 0.20, 1]
  const ease = [0.76, 0, 0.24, 1]
  const duration = 1.2
  // const duration = 0.75
  const transition = { duration, ease }
  const viewOnce = {once: true}
  return {
    transition,
    duration,
    ease,
    viewOnce
  }
}

export default animA
